// dashboard.component.tsx (modernized with hooks and Redux Toolkit)
import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { Link } from 'react-router-dom';
import DashboardItem from './dashboard-item';
import { getDashboards, reset as resetDashboards } from './dashboard.reducer';
import { resetWidgets } from './widget.reducer';
import { IRootState } from 'app/config/store';
import { MdBorderAll } from 'react-icons/md';
import './styles/dashboard.scss';
import DeleteDashboard from './dashboard-delete-dialog';
import { Spinner } from 'reactstrap';

const Dashboard = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const [shareModal, setShareModal] = useState(false);
  const [selectedDashboard, setSelectedDashboard] = useState<{ id: number; name: string } | null>(null);
  const [deleteModal, setDeleteModal] = useState(false);

  const dashboardItems = useAppSelector((state: IRootState) => state.dashboard.dashboards);
  const loading = useAppSelector((state: IRootState) => state.dashboard.loading);
  const totalItems = useAppSelector((state: IRootState) => state.dashboard.totalItems);
  const account = useAppSelector((state: IRootState) => state.authentication.account);

  useEffect(() => {
    dispatch(resetDashboards());
    dispatch(resetWidgets());
    dispatch(getDashboards({}));
  }, [dispatch]);

  const onShare = dashboard => {
    setSelectedDashboard(dashboard);
    setShareModal(true);
  };

  const toggleSharing = () => {
    setShareModal(!shareModal);
  };

  const onDelete = dashboard => {
    setSelectedDashboard(dashboard);
    setDeleteModal(true);
  };

  const toggleDeleteModal = () => {
    setDeleteModal(!deleteModal);
  };

  const dashboardSharingProps = {
    dashboard: selectedDashboard,
    toggleSharing,
  };

  const dashboardDeleteProps = {
    dashboard: selectedDashboard,
    toggleDeleteModal,
  };

  return (
    <>
      {loading ? (
        <center className="d-flex justify-content-center align-items-center vh-100">
          <Spinner color="primary" />
        </center>
      ) : (
        <>
          <div className="full-width d-flex justify-content-between">
            <h3 id="dashboard-heading">My Dashboards</h3>
            <div className="dashboard-create-div">
              <Link to={`new`} className="btn btn-primary float-right dashboard-create-btn jh-create-entity" id="jh-create-entity">
                <MdBorderAll />
                <span style={{ marginLeft: '5px' }}>Create Dashboard</span>
              </Link>
            </div>
            {/*shareModal && <ShareDashboard {...dashboardSharingProps} />*/}
            {deleteModal && selectedDashboard && <DeleteDashboard {...dashboardDeleteProps} />}
          </div>
          {dashboardItems && dashboardItems?.length > 0 ? (
            <div id="myDashboards">
              {dashboardItems &&
                dashboardItems?.length > 0 &&
                dashboardItems?.map(item => (
                  <DashboardItem loggedInUser={account.id} key={item.id} dashboard={item} onShare={onShare} onDelete={onDelete} />
                ))}
            </div>
          ) : (
            <div className="alert alert-warning">No Dashboards Found</div>
          )}
        </>
      )}
    </>
  );
};

export default Dashboard;
